var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15C9 15.5523 9.44771 16 10 16C10.5523 16 11 15.5523 11 15C11 14.4477 10.5523 14 10 14C9.44771 14 9 14.4477 9 15ZM10 0C4.48 0 -2.38419e-07 4.48 -2.38419e-07 10C-2.38419e-07 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 4C8.13169 4 6.56355 5.27927 6.12331 7.0101C5.98716 7.54534 6.44771 8 7 8C7.55228 8 7.97995 7.52542 8.24622 7.04157C8.58709 6.42214 9.24664 6 10 6C11.1 6 12 6.9 12 8C12 9.76947 9.65171 9.77774 9.11038 12.0069C8.98005 12.5436 9.44771 13 10 13C10.5523 13 10.9768 12.5295 11.2172 12.0323C11.9066 10.6067 14 10.0884 14 8C14 5.79 12.21 4 10 4Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.dbe21273bf3e3b57b48ecb88fad10305.svg";
export { ForwardRef as ReactComponent };